import * as THREE from 'three';

const RADIUS = 8;
const BOUNCE = 1.05;
const START_PAUSE = 1000;
const START_SPEED = 3;

export default class Ball extends THREE.Mesh {
  constructor (position) {
    const ballMaterial = new THREE.MeshLambertMaterial({color: 0xFFFFFF});
    super(new THREE.SphereGeometry(RADIUS), ballMaterial);

    this.r = 8;
    this.alive = true;

    this.position.x = this._startX = position.x;
    this.position.y = this._startY = position.y;
    this.position.z = this._startZ = position.z;

    this.velocity = new THREE.Vector3(0,0,-3);

    this.travelDirection = -1;

    this.castShadow = true;
  }

  bounce (relativeHitPoint) {
    let xFactor, yFactor, zFactor, xDirection;

    if (Math.abs(relativeHitPoint.x) > 10) {
      xDirection = Math.sign(relativeHitPoint.x);
    } else {
      xDirection = 0;
    }
    this.velocity.z *= -BOUNCE;
    this.velocity.x = xDirection * (Math.abs(this.velocity.z) / 3);
  }

  reset () {
    this.position.x = this._startX;
    this.position.y = this._startY;
    this.position.z = this._startZ;
    this.velocity = new THREE.Vector3(0,0,0);
    this.alive = false;
    this.material.color.setHex(0xFF6666);

    setTimeout(() => {
      this.velocity.z = START_SPEED * (Math.random() > 0.5 ? 1: -1);
      this.alive = true;
      this.material.color.setHex(0xFFFFFF);
    }, START_PAUSE);
  }

  update (t) {
    this.position.add(this.velocity);
  }

  get front () {
    return this.position.z - (RADIUS / 2);
  }

  get back () {
    return this.position.z + (RADIUS / 2);
  }

  get left () {
    return this.position.x + (RADIUS / 2);
  }

  get right () {
    return this.position.z +- (RADIUS / 2);
  }
}



// WEBPACK FOOTER //
// ./src/entities/ball.js